import request from '@/utils/request'
//获取资讯，攻略文章列表
export function GetWenzhang(data) {
  return request({
    url: '/html/wenzhang',
    method: 'get',
    params: data 
  })
}
export function GetWenzhangdefault() {
  return request({
    url: '/wenzhang/wenzhangdefault',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/wenzhang.js